export const URL_API = 'https://mun42.com/wp-json/app/v1';
export const API_KEY = '1ec16e4666b5b2a9e2705ba7c739cf47';
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER';
